
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Asset, Workorder, WorkordersApi } from 'performo-api';

import { ColumnDisplayOption } from '@/models/ColumnDisplayOption';

import AddAssetComponent from '@/components/orders/AddAssetComponent.vue';
import { mapGetters } from 'vuex';

@Component({
  components: {
    AddAssetComponent
  },
  computed: mapGetters({
    api: 'ordersApi'
  })
})
export default class OrderAssetListComponent extends Vue {
  private api!: WorkordersApi;

  @Prop({ required: true })
  private order!: Workorder;

  @Prop({})
  private selectedAssets!: Asset[];

  get assetDisplayOptions(): ColumnDisplayOption[] {
    return [
      { displayName: 'Code', columnName: 'assetCode', dontSort: true },
      { displayName: 'Name', columnName: 'name', dontSort: true },
      { displayName: 'Status', columnName: 'status', dontSort: true },
      { displayName: 'Critical #', columnName: 'criticalNum', dontSort: true },
      { displayName: 'Problem', columnName: 'problem', dontSort: true },
      { displayName: 'Notes', columnName: 'notes', dontSort: true },
      { displayName: 'Downtime', columnName: 'downtime', dontSort: true }
    ];
  }

  private assetClicked(asset: Asset) {
    if (asset.assetId) {
      this.$router.push({
        name: 'asset-detail',
        params: { id: asset.assetId.toString() }
      });
    }
  }

  private async assetAddedHandler(assets: Asset[]) {
    if (this.order.workorderId) {
      assets.forEach(async (asset) => {
        if (asset.assetId) {
          try {
            await this.api.addAssetToOrder({
              workorderAssetCreateCommand: {
                workorderId: this.order.workorderId,
                assetId: asset.assetId
              }
            });
            this.$emit('assetAdded', asset.assetId);
          } catch (error) {
            this.$emit('error', error);
          }
        }
      });
    } else {
      this.$emit('assets-picked', assets);
    }
  }
}
